// extracted by mini-css-extract-plugin
module.exports = {"nodes":"nodes___3ot_T","node":"node___2ItcQ","img":"img___3CGY9","about":"about___36RRq","labels":"labels___GHck3","label":"label___25zGa","PopoverLabels":"PopoverLabels___2F6W4"};